import { useHydrateStorageZaps } from "./useHydrateStorageZaps";
import { useQueryStorageZaps } from "./useQueryStorageZaps";

interface Input {
  id: number | undefined;
  enabled?: boolean;
}
export function useStorageZap({ id, enabled = true }: Input) {
  const { response, isFetching, isLoading } = useQueryStorageZaps({
    ids: id ? [id] : [],
    enabled: !!id && enabled,
  });

  const storageZap = id ? response[id] : undefined;
  const { hash } = useHydrateStorageZaps([storageZap]);

  const zap = id && hash[id] ? hash[id] : storageZap;

  return {
    zap,
    isFetching,
    isLoading,
  };
}
